import React, { useContext, useState } from "react";
import Cropper from "react-easy-crop";
import { Card, CardContent, Slider, Typography } from "@mui/material";
import { Button } from "react-bootstrap";
import { ContainerScreenGeneral } from "../../components";
import { useNavigate } from "react-router-dom";
import svgAccesibilidad from "/ACCESIBILIDAD-N.svg";
import { useWindowSize } from "../../hooks";
import { UserContext } from "../../context";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const MCD = () => {
  const navigate = useNavigate();
  const { actions: ua } = useContext(UserContext);
  const size = useWindowSize();
  const { width } = size;

  const menuOptions = [
    {
      title: "Infracciones nuevas",
      description: "Gestion de multas realizadas mediante NqnAccesible.",
      path: "/mcd/infracciones-nuevas",
      roles: [],
      icon: <img src={svgAccesibilidad} style={{ width: "65px", height: "65px" }} />,
    },
    {
      title: "Infracciones anuladas",
      description: "Gestion de denuncias que han sido chequeadas y anuladas.",
      path: "/mcd/infracciones-anuladas",
      roles: [],
      icon: <RemoveCircleOutlineIcon style={{ width: "65px", height: "65px", color:'#dc3545' }} />,
    },
  ]

  return (
    <ContainerScreenGeneral linkBack={"/"} titulo={"MCD"} size={"lg"}>

      <div className={` ${width >= 640 ? "" : "flex-column"} d-flex flex-wrap   mx-auto justify-content-center w-100   py-2  pb-5 `}
        style={{ maxWidth: "800px" }}
      >
        {menuOptions.map((opc) => {
          if (
            opc.roles.some((role) =>
              ua.getPerfil().roles?.some((userRole) => userRole.name == role)
            ) ||
            opc.roles.length == 0
          ) {
            return (
              <section
                key={opc.title}
                className={`${width < 640 ? "col-12 p-3 " : width < 992 ? "col-4 p-0" : "col-4 p-3"
                  } `}
              >
                <Card
                  key={opc.title}
                  className={`shadow-lg rounded-2xl d-flex flex-column align-items-center p-2 py-3`}
                >
                  {opc.icon}
                  <h5
                    style={{ color: "#133040", fontSize: "20px" }}
                    className=" font-bold m-0 pt-3 "
                  >
                    {opc.title}
                  </h5>
                  <CardContent className="pt-2">
                    <p
                      className="text-gray-600 text-center "
                      style={{ fontSize: "16px", width: "180px" }}
                    >
                      {opc.description}
                    </p>

                    <Button
                      size="md"
                      style={{ background: "#127AE2", color: "#127AE2" }}
                      className="mt-3 w-100 btn "
                      onClick={() => navigate(opc.path)}
                    >
                      Ir a {opc.title}
                    </Button>
                  </CardContent>
                </Card>
              </section>
            );
          }
        })}
      </div>
      {/* <div>
        <Button onClick={() => navigate("/mcd/infracciones-nuevas")}>Infracciones Nuevas</Button>
      </div> */}
    </ContainerScreenGeneral>
  );
};

export default MCD;
